import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import JobSeekerRoutes from "./Routes/JobSeekerRoutes";
import EmployerRoutes from "./Routes/EmployerRoutes";
import CommonRoutes from "./Routes/CommonRoutes";
import { ToastContainer } from "react-toastify";
import { AuthProvider } from "./authContext/index";
import { useDispatch, useSelector } from "react-redux";
import { getProfanityWord } from "./redux/Profanity";
import { axiosAPI } from "./views/Axios/Axios";
import RouteValidator from "./RouteValidator";
import { getAllLabels } from "./redux/AllLabels";

const DEFAULT_LANGUAGE = "es";
const DEFAULT_LANGUAGE_VERSION = "spanish-default-v1";

const getInitialLanguage = () => {
  if (localStorage.getItem("defaultLanguageVersion") !== DEFAULT_LANGUAGE_VERSION) {
    localStorage.setItem("language", DEFAULT_LANGUAGE);
    localStorage.setItem("defaultLanguageVersion", DEFAULT_LANGUAGE_VERSION);
  }

  return localStorage.getItem("language") || DEFAULT_LANGUAGE;
};

function App() {
  const dispatch = useDispatch();
  const language = getInitialLanguage();
  const getLabels = (language) => {
    dispatch(getAllLabels(language));
    dispatch(getProfanityWord())
  };
  useEffect(() => {
    getLabels(language);
  }, []);

  return (
    <Router>
      <RouteValidator />
      <AuthProvider>
        <CommonRoutes />
        <JobSeekerRoutes />
        <EmployerRoutes />
        <ToastContainer />
      </AuthProvider>
    </Router>
  );
}

export default App;
